// @flow strict

import type {CustomNoteWritebackState} from 'src/reducers/custom-note-writeback';
import type {NodeSchedule} from 'src/types/node-schedule';


export const RECEIVE_CUSTOM_NOTE_WRITEBACK_INFO =
  'custom-note-writeback/receive-info';
export const UPDATE_CUSTOM_NOTE_WRITEBACK_INFO =
  'custom-note-writeback/update-info';
export const RESET_CUSTOM_NOTE_WRITEBACK_STATE =
  'custom-note-writeback/reset-state';
export const UPDATE_NODE_SCHEDULE =
  'custom-note-writeback/update-node-schedule';
type CustomNoteWritebackPayload = $Shape<CustomNoteWritebackState>;

type RecieveCustomNoteWritebackInfoAction = {
  type: typeof RECEIVE_CUSTOM_NOTE_WRITEBACK_INFO,
  payload: CustomNoteWritebackPayload,
};

type UpdateCustomNoteWritebackInfoAction = {
  type: typeof UPDATE_CUSTOM_NOTE_WRITEBACK_INFO,
  payload: CustomNoteWritebackPayload,
};

type ResetStateAction = {
  type: typeof RESET_CUSTOM_NOTE_WRITEBACK_STATE,
};

type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE,
  payload: $Partial<NodeSchedule>,
};

export type CustomNoteWritebackAction =
  | RecieveCustomNoteWritebackInfoAction
  | UpdateCustomNoteWritebackInfoAction
  | UpdateNodeScheduleAction
  | ResetStateAction;

export const receiveCustomNoteWriteback = (
  payload: CustomNoteWritebackState,
): RecieveCustomNoteWritebackInfoAction => ({
  type: RECEIVE_CUSTOM_NOTE_WRITEBACK_INFO,
  payload,
});

export const updateCustomNoteWriteback = (
  payload: CustomNoteWritebackPayload,
): UpdateCustomNoteWritebackInfoAction => ({
  type: UPDATE_CUSTOM_NOTE_WRITEBACK_INFO,
  payload,
});
export const updateNodeSchedule = (
  payload: $Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});
export const resetCustomNoteWriteback = (): ResetStateAction => ({
  type: RESET_CUSTOM_NOTE_WRITEBACK_STATE,
});
